export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4725.53a48847.jpg";